import {
  Button,
  Flex,
  Heading,
  Modal,
  type FormInstance,
} from "@ir/ui";
import type { ReactNode } from "react";
import type { MasterDataAddEditModalMode } from "./useMasterDataAddEditModal";

interface MasterDataAddEditModalProps {
  mode: MasterDataAddEditModalMode | null;
  createTitle: string;
  editTitle: string;
  isSaving: boolean;
  isFormSubmittable: boolean;
  form: FormInstance;
  onClose: () => void;
  children: ReactNode;
}

export const MasterDataAddEditModal = ({
  mode,
  createTitle,
  editTitle,
  isSaving,
  isFormSubmittable,
  form,
  onClose,
  children,
}: MasterDataAddEditModalProps) => {
  return (
    <Modal
      isOpen={mode != null}
      onClose={onClose}
      size="large"
      closable
      headerContent={
        <Heading level={6} className="text-grey-700 font-bold m-0">
          {mode === "edit" ? editTitle : createTitle}
        </Heading>
      }
      footerContent={
        <Flex gap={0.5}>
          <Button
            size="small"
            onPress={onClose}
            color="grey"
            isDisabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            size="small"
            color="primary"
            onPress={() => form.submit()}
            isLoading={isSaving}
            isDisabled={isSaving || !isFormSubmittable}
          >
            Save
          </Button>
        </Flex>
      }
    >
      {mode != null ? children : null}
    </Modal>
  );
};
